// XAPiT Footer
import { Link } from "react-router-dom";

const Footer = (props) => {
  return (
    <div className="Footer-Container">
      <nav>
        <ul>
          <span>Copyright @2022</span> - <Link to="/privacy">Privacy</Link> -{" "}
          <Link to="/tos">Terms of Service</Link> -{" "}
          <Link to="/contact">Contact</Link> - <Link to="/faq">FAQs</Link>
        </ul>
      </nav>
    </div>
  );
};

export default Footer;
